import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetAllContainerTypesAdminQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.AdminContainerTypeFilter>;
  skip?: Types.InputMaybe<Types.Scalars['Int']>;
  take?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type GetAllContainerTypesAdminQuery = { __typename?: 'Query', getAllContainerTypesAdmin: { __typename?: 'AdminContainerTypePage', total_count: number, unfiltered_count: number, items: Array<{ __typename?: 'AdminContainerType', id: number, name?: string | null, names_by_language_string: string, class: string, order_key: number, icon_url?: string | null, size_helper?: string | null, image_url?: string | null, country_codes: Array<string>, hex_code?: string | null, packing_unit: number, group_id?: number | null, sku?: string | null, branding?: string | null, legal_owner?: string | null, packing_instructions?: string | null, weight: number, archived: boolean, segment?: string | null, container_equivalent_type_ids: Array<number>, container_equivalents_id?: number | null }> } };


export const GetAllContainerTypesAdminDocument = gql`
    query GetAllContainerTypesAdmin($filter: AdminContainerTypeFilter, $skip: Int, $take: Int) {
  getAllContainerTypesAdmin(filter: $filter, skip: $skip, take: $take) {
    items {
      id
      name
      names_by_language_string
      class
      order_key
      icon_url
      size_helper
      image_url
      country_codes
      hex_code
      packing_unit
      group_id
      sku
      branding
      legal_owner
      packing_instructions
      weight
      archived
      segment
      container_equivalent_type_ids
      container_equivalents_id
    }
    total_count
    unfiltered_count
  }
}
    `;

/**
 * __useGetAllContainerTypesAdminQuery__
 *
 * To run a query within a React component, call `useGetAllContainerTypesAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllContainerTypesAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllContainerTypesAdminQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function useGetAllContainerTypesAdminQuery(baseOptions?: Apollo.QueryHookOptions<GetAllContainerTypesAdminQuery, GetAllContainerTypesAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllContainerTypesAdminQuery, GetAllContainerTypesAdminQueryVariables>(GetAllContainerTypesAdminDocument, options);
      }
export function useGetAllContainerTypesAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllContainerTypesAdminQuery, GetAllContainerTypesAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllContainerTypesAdminQuery, GetAllContainerTypesAdminQueryVariables>(GetAllContainerTypesAdminDocument, options);
        }
export type GetAllContainerTypesAdminQueryHookResult = ReturnType<typeof useGetAllContainerTypesAdminQuery>;
export type GetAllContainerTypesAdminLazyQueryHookResult = ReturnType<typeof useGetAllContainerTypesAdminLazyQuery>;
export type GetAllContainerTypesAdminQueryResult = Apollo.QueryResult<GetAllContainerTypesAdminQuery, GetAllContainerTypesAdminQueryVariables>;